import { render, staticRenderFns } from "./notice-add.vue?vue&type=template&id=764899d9&scoped=true"
import script from "./notice-add.vue?vue&type=script&lang=js"
export * from "./notice-add.vue?vue&type=script&lang=js"
import style0 from "./notice-add.vue?vue&type=style&index=0&id=764899d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764899d9",
  null
  
)

export default component.exports